import { BlueGreen } from './BlueGreen.es.js';
import { BluePurple } from './BluePurple.es.js';

/**
 * List of available gradients.
 */ const gradients = {
    BlueGreen,
    BluePurple
};

export { gradients };
//# sourceMappingURL=index.es.js.map
